<template>
  <div class="setting-user-two-factor-dialog">
    <el-dialog custom-class="with-title" title="2段階認証を有効化" :visible.sync="visible" @close="close">
      <div class="dialog-content">
        <div class="message message-info mb-x1">
          2段階認証を設定するには、認証システムアプリをスマートフォンにインストールする必要があります。<br />インストール完了後、アプリから下記バーコードをスキャンし、アプリに表示されている認証コードを入力してください。<br />ヘルプ:
          <a href="https://help-atelu.comnico.jp/2step-verification-login" target="_blank"
            >認証システムアプリをインストールする</a
          >
        </div>
        <div class="message message-error mb-x1" v-if="is_approval_failed">
          コードが無効であるか、期限が切れています。もう一度入力してください。
        </div>
        <img class="mb-x1" v-if="qrcode_url" :src="qrcode_url" />
        <div>
          <label>パスワード</label>
          <div class="input-container mt-x1">
            <el-input
              class="success input"
              placeholder="6桁のコードを入力"
              type="text"
              v-model="password"
              tabindex="1"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="dialog-footer" slot="footer">
        <el-button type="default" @click="close">キャンセル</el-button>
        <el-button type="primary" @click="checkTwoFactor" :disabled="isDisabled || is_submit"
          >認証コードを確認</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

img {
  width: 180px;
}

label {
  font-size: $font-size;
  font-weight: bold;
}

.input-container {
  width: $spacing-unit * 40;
}
</style>

<script lang="ts">
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import api from '@/client/core/api'
import { useSystemStore } from '@/client/store/useSystemStore'

export default defineComponent({
  data() {
    return {
      password: '',
      qrcode_url: '',
      is_submit: false,
      visible: false,
      is_approval_failed: false
    }
  },
  computed: {
    ...mapState(useSystemStore, {
      user: state => state.user
    }),

    isDisabled() {
      const regex = /\b\d{6}\b/g

      return !this.password.trim() || !this.password.match(regex) || this.password.length !== 6
    }
  },
  methods: {
    ...mapActions(useSystemStore, {
      setSystemUser: 'setUser'
    }),

    /**
     * 2段階認証の設定をする
     */
    async checkTwoFactor() {
      if (this.is_submit) {
        return
      }

      const params = {
        code: this.password
      }

      this.is_submit = true

      const result = await api.post('v1/two_factor/approval', params)

      this.is_submit = false

      if (result && result.data) {
        this.visible = false

        // システムユーザーストアに変更
        const user = Object.assign({}, this.user, { isTwoFactor: 1 })

        this.setSystemUser(user)

        return this.$notify({
          title: '2段階認証を設定しました。',
          message: '',
          customClass: 'success',
          duration: 5000
        })
      }

      if (result && result.error && result.error.type === 'PERMISSION_DENIED') {
        this.is_approval_failed = true
        return
      }

      this.is_approval_failed = false

      this.$notify({
        title: '2段階認証の設定に失敗しました。',
        message: '',
        customClass: 'danger',
        duration: 5000
      })
    },

    /**
     * ダイアログをあく
     */
    async open() {
      this.is_approval_failed = false
      this.visible = true

      const result = await api.post('v1/two_factor', undefined)

      if (result && result.data) {
        this.qrcode_url = result.data.qrcode_url
      }
    },

    /**
     * データをリセットする
     */
    reset() {
      this.password = ''
      this.qrcode_url = ''
    },

    /**
     * ダイアログを閉じる
     */
    close() {
      this.reset()
      this.visible = false
    }
  }
})
</script>
